import React, { createContext, useContext, useCallback } from 'react';
import { useCampaign } from '../Logic/CampaignContext';
const SurvivorContext = createContext(null);
export function SheetProvider({ survivorId, children }) {
  return <SurvivorContext.Provider value={survivorId}>{children}</SurvivorContext.Provider>;
}
export function usePersistedState(key, fallback) {
  const survivorId = useContext(SurvivorContext);
  const { current, updateSheetField } = useCampaign();
  const survivor = current.survivors.find(s => s.id === survivorId);
  const field = key.split(`__survivor__${survivorId}__`)[1];
  if (!survivor || !field) throw Error('Survivor sheet requires a campaign survivor');
  const value = field === 'name' ? survivor.name : (survivor.sheet?.[field] ?? fallback);
  const setValue = useCallback(next => updateSheetField(survivorId, field, next, fallback),
    [survivorId, field, updateSheetField]); // fallback is only read when the field is unset
  return [value, setValue];
}
